<footer class="footer">
    <div class="footer-content">
        <div class="footer-container">
            <!-- Logo -->
            <div class="footer-logo-section">
                <img src="https://nld.gob.mx/assets/logos/logo2nld.png" alt="Gobierno de Nuevo Laredo"
                    class="footer-logo" />
            </div>

            <!-- Enlaces Rápidos -->
            <div class="footer-links">
                <span class="links-title">Enlaces</span>
                <div class="links-grid">
                    <a routerLink="/cabildo" class="footer-nav-link">
                        <i class="bi bi-chevron-right"></i> Cabildo
                    </a>
                    <a routerLink="/noticias" [queryParams]="{id: '0'}" class="footer-nav-link">
                        <i class="bi bi-chevron-right"></i> Sala de Prensa
                    </a>
                    <a routerLink="/transparencia" class="footer-nav-link">
                        <i class="bi bi-chevron-right"></i> Transparencia
                    </a>
                    <a href="https://www.comapanuevolaredo.gob.mx/sitio/" target="_blank" class="footer-nav-link">
                        <i class="bi bi-chevron-right"></i> COMAPA
                    </a>
                    <a href="https://dif.nld.gob.mx/" target="_blank" class="footer-nav-link">
                        <i class="bi bi-chevron-right"></i> DIF
                    </a>
                    <a href="https://empleo.nld.gob.mx" target="_blank" class="footer-nav-link">
                        <i class="bi bi-chevron-right"></i> Bolsa de Empleo
                    </a>
                    <a href="https://copladem.nld.gob.mx/" target="_blank" class="footer-nav-link">
                        <i class="bi bi-chevron-right"></i> COPLADEM
                    </a>
                    <a href="https://invest.nld.gob.mx/" target="_blank" class="footer-nav-link">
                        <i class="bi bi-chevron-right"></i> INVEST
                    </a>
                </div>
            </div>

            <!-- Información de Contacto -->
            <div class="footer-info">
                <span class="info-title">Contacto</span>
                <div class="contact-item">
                    <i class="bi bi-geo-alt"></i>
                    <span>Av. Vicente Guerrero #1500, CP 88000, Sector Centro, Nuevo Laredo, Tamaulipas, México</span>
                </div>
                <div class="contact-item">
                    <i class="bi bi-telephone"></i>
                    <span>(867) 711-3500</span>
                </div>
                <div class="contact-item">
                    <i class="bi bi-envelope"></i>
                    <span>contacto&#64;nld.gob.mx</span>
                </div>
            </div>

            <!-- Redes Sociales -->
            <div class="footer-social">
                <span class="social-title">Síguenos:</span>
                <div class="social-links">
                    <a href="https://www.facebook.com/gobiernodenuevolaredo" class="social-link" target="_blank"
                        rel="noopener">
                        <i class="bi bi-facebook"></i>
                    </a>
                    <a href="https://x.com/Gob_NuevoLaredo" target="_blank" class="social-link">
                        <i class="bi bi-twitter-x"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- Copyright -->
    <div class="footer-bottom">
        <p>Todos los Derechos Reservados 2026 <a href="/" class="footer-link">Gobierno de Nuevo Laredo</a></p>
    </div>
</footer>